"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var SvgRocket = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ fill: "none", height: 23, width: 23, xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M22.973 1.717a1.788 1.788 0 0 0-1.69-1.69c-1.844-.1-5.451-.003-8.9 1.781-1.759.91-3.619 2.452-5.103 4.231l-.054.066-3.368.26a1.778 1.778 0 0 0-1.355.798L.205 10.638c-.233.352-.27.792-.099 1.178.17.386.521.654.938.719l2.838.44-.03.165a1.787 1.787 0 0 0 .501 1.554l3.953 3.953a1.791 1.791 0 0 0 1.554.5l.166-.029.44 2.838A1.227 1.227 0 0 0 11.682 23c.237 0 .473-.07.678-.205l3.476-2.298c.464-.307.755-.8.797-1.355l.26-3.368.066-.054c1.78-1.484 3.322-3.344 4.231-5.103 1.785-3.45 1.883-7.057 1.782-8.9zm-7.879 17.656-3.325 2.198-.428-2.766c1.405-.413 2.795-1.074 4.12-1.96l-.17 2.193a.439.439 0 0 1-.197.335zm-5.835-1.68-3.953-3.952a.437.437 0 0 1-.125-.38c.118-.702.3-1.37.527-2l5.93 5.93a11.64 11.64 0 0 1-2 .527.437.437 0 0 1-.38-.124zM3.962 7.71l2.194-.17c-.887 1.325-1.548 2.715-1.962 4.12l-2.765-.428 2.198-3.325a.439.439 0 0 1 .335-.197zm12.135 6.976a15.448 15.448 0 0 1-3.119 2.04l-6.703-6.703a15.716 15.716 0 0 1 2.04-3.12c1.374-1.646 3.082-3.066 4.687-3.897 3.166-1.637 6.501-1.725 8.208-1.632a.442.442 0 0 1 .417.417c.093 1.707.005 5.042-1.632 8.208-.83 1.605-2.251 3.313-3.898 4.687z", fill: "#5029ef" }) }))); };
exports.default = SvgRocket;
